// extracted by mini-css-extract-plugin
export var component = "HeaderUtilsMenu-module--component--kgNi+";
export var item = "HeaderUtilsMenu-module--item--wRWxO";
export var link = "HeaderUtilsMenu-module--link--9-BaX";
export var list = "HeaderUtilsMenu-module--list--faPpl";